export default "__VITE_ASSET__DXvuErWY__"